export const BUS_EVENTS_SHOP = {
    ORDER_COMPLETED:'ORDER_COMPLETED',
    WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT_SHOP',
}